import styled from 'styled-components';
import { styles, mixins } from '4all-ui/styles';

export const Container = styled.div``;

export const BoxContainer = styled.div`
  ${mixins.flexPosition({ justify: 'space-between' })}
  width: 100%;
`;

export const Item = styled.div`
  ${mixins.flexPosition({})}
  margin-bottom: 20px;

  &:last-child {
    margin-bottom: 0;
  }
`;

export const ItemDescription = styled.div`
  ${mixins.fontStyle(
    styles.colors.GRAY_DARKER,
    styles.fontSizes.SIZE_5,
    styles.fontWeights.SEMIBOLD
  )}
  line-height: 15px;
  margin-bottom: 5px;
`;

export const OrderPackageInfo = styled.div`
  ${mixins.fontStyle(styles.colors.GRAY_DARKER, styles.fontSizes.SIZE_7, styles.fontWeights.NORMAL)}
  line-height: 15px;
  margin-bottom: 20px;
`;

export const ItemTitle = styled.div`
  ${mixins.fontStyle(
    styles.colors.GRAY_MEDIUM_3,
    styles.fontSizes.SIZE_7,
    styles.fontWeights.NORMAL
  )}
  line-height: 15px;
  width: 85px;
`;

export const ItemValue = styled.div`
  ${mixins.fontStyle(styles.colors.GRAY_DARKER, styles.fontSizes.SIZE_7, styles.fontWeights.NORMAL)}
  line-height: 15px;
`;



// WEBPACK FOOTER //
// ./src/screens/Home/Components/OrderDetails/style.js